import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
  Stack,
  Container,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import TitleValue from "../../../../components/title-value";
import ButtonUI from "../../../../components/button/buttons";
import {
  beneficiaryAccountType,
  counterpartInstitution,
} from "../../../../const/transference.cost";
import usePostCreateAccountBank from "../../../../service/userBankAccount/createUserAccountBank";

type FormData = {
  name: string;
  email: string;
  account_number: string;
  type_of_account: string;
  code_bank: string;
  setNotification?: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      message: string;
      severity: "success" | "info" | "warning" | "error";
    }>
  >;
};

const CreateFormAccount = ({
  authToken,
  setOpenModal,
  setNotification,
  refresh,
}: any) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormData>();

  const { loading, createAccount } = usePostCreateAccountBank();

  const onSubmit = async (formData: FormData) => {
    try {
      const result = await createAccount(formData);
      if (result?.success === true) {
        setNotification({
          open: true,
          message: "Se ha creado una cuenta bancaria",
          severity: "success",
        });
        setOpenModal(false);
        refresh();
      } else {
        setNotification({
          open: true,
          message: "Ha occurido un error al generar un cuenta bancaria",
          severity: "error",
        });
      }
    } catch (err: any) {
      setNotification({
        open: true,
        message: (err as Error).message || "Ocurrió un error",
        severity: "error",
      });
    }
  };

  return (
    <Container fixed maxWidth="xs">
      <TitleValue title="Agregegar una cuenta" value="" />

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        {/* Nombre */}
        <Controller
          name="name"
          control={control}
          defaultValue=""
          rules={{
            required: "El nombre es obligatorio",
            maxLength: {
              value: 100,
              message: "Debe tener un máximo de 100 caracteres",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              sx={{ width: "400px" }}
              label="Nombre"
              fullWidth
              margin="normal"
              error={!!errors.name}
              helperText={errors.name?.message}
            />
          )}
        />

        <Controller
          name="account_number"
          control={control}
          defaultValue=""
          rules={{
            required: "la cuenta es obligatorio",
            minLength: {
              value: 10,
              message: "Debe tener al menos 10 caracteres",
            },
            maxLength: {
              value: 20,
              message: "Debe tener un máximo de 20 caracteres",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              sx={{ width: "400px" }}
              label="Cuenta"
              fullWidth
              margin="normal"
              error={!!errors.account_number}
              helperText={errors.account_number?.message}
            />
          )}
        />

        <Controller
          name="type_of_account"
          control={control}
          defaultValue=""
          rules={{ required: "Selecciona un tipo de cuenta" }}
          render={({ field }) => (
            <FormControl
              sx={{ width: "400px" }}
              fullWidth
              margin="normal"
              error={!!errors.type_of_account}
            >
              <InputLabel id="tipo-label">Tipo de cuenta</InputLabel>
              <Select {...field} labelId="tipo-label" label="Tipo de cuenta">
                {beneficiaryAccountType.map((person) => (
                  <MenuItem key={person.key} value={person.key}>
                    {person.description}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.type_of_account?.message}</FormHelperText>
            </FormControl>
          )}
        />

        <Controller
          name="code_bank"
          control={control}
          defaultValue=""
          rules={{ required: "Selecciona un tipo de cuenta" }}
          render={({ field }) => (
            <FormControl
              sx={{ width: "400px" }}
              fullWidth
              margin="normal"
              error={!!errors.code_bank}
            >
              <InputLabel id="genero-label">Banco</InputLabel>
              <Select {...field} labelId="genero-label" label="Banco">
                {[...counterpartInstitution]
                  .sort((a, b) => a.participant.localeCompare(b.participant))
                  .map((person) => (
                    <MenuItem key={person.key} value={person.key}>
                      {person.participant}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText>{errors.code_bank?.message}</FormHelperText>
            </FormControl>
          )}
        />

        <Stack
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
        >
          <ButtonUI title="Regresar" onClick={() => setOpenModal(false)} />
          <ButtonUI
            type="submit"
            title="Agregar cuenta"
            color="primary"
            disabled={loading}
          />
        </Stack>
      </form>
    </Container>
  );
};

export default CreateFormAccount;
